/**
 * Responsibility: Build shared UI action refs for normalized action metadata.
 * Scope: Ref/id shaping only; no action execution or orchestration.
 */
import type { ActionTargetRef, ActionToolRef } from "@anyquest/shared-core"

export function toRefId(value: string): string {
  return String(value ?? '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '')
}

export function buildActionTarget(
  kind: ActionTargetRef['kind'],
  label: string,
  id?: string,
): ActionTargetRef {
  const trimmed = String(label ?? '').trim() || kind
  const resolvedId = id ?? (toRefId(trimmed) || kind)
  return {
    kind,
    id: String(resolvedId),
    label: trimmed,
  }
}

export function buildToolRef(
  kind: ActionToolRef['kind'],
  id: string,
  label: string,
): ActionToolRef {
  const trimmedLabel = String(label ?? '').trim() || kind
  const resolvedId = toRefId(id || trimmedLabel) || kind
  return {
    kind,
    id: String(resolvedId),
    label: trimmedLabel,
  }
}
